export enum ShowroomTestIds {
  BRAND_INFO = 'brand-Info-details',
  ABOUT_TEXT_DETAILS = 'about-text-details',
  TAG_DETAILS = 'tag-details',
  ABOUT_DETAILS = 'about-details',
  PRICE_TAG_DETAILS = 'price-tag-details',
  FEATURED_PRODUCTS_DETAILS = 'featured-produtcs-details',
  FEATURED_MEDIA_DETAILS = 'featured-media-details',
  FEATURED_CATALOG_DETAILS = 'featured-catalog-details',
  FEATURED_CONTACTS_DETAILS = 'featured-contacts-details',
  FEATURED_CONTACTS_BOX_DETAILS = 'featured-contacts-box-details',
  FEATURED_CONTACTS_GRID_DETAILS = 'featured-contacts-grid-details',
  FEATURED_EDIT_SHOWROOM_DETAILS = 'featured-edit-button-details',
  FEATURED_SHOWROOM_CONTAINER_DETAILS = 'featured-showroom-container-details',
}
